import type { IntlShape } from 'react-intl';

export const getDomainKeys = (
  intl: IntlShape,
): Record<string, { id: string; label: string; isAcronym?: boolean }> => {
  return {
    workday: {
      id: 'workday',
      label: 'Workday',
    },
    clm: {
      id: 'clm',
      label: 'CLM',
    },
    ci: {
      id: 'ci',
      label: 'CI',
    },
    editor: {
      id: 'editor',
      label: intl.formatMessage({
        id: 'Integrations.chipEditor',
        defaultMessage: 'Editor',
        description: 'Editor domain option label',
      }),
    },
    'e-signature': {
      id: 'e-signature',
      label: intl.formatMessage({
        id: 'Integrations.chipESignature',
        defaultMessage: 'E-Signature',
        description: 'E-Signature domain option label',
      }),
    },
    'storage provider': {
      id: 'storage provider',
      label: intl.formatMessage({
        id: 'Integrations.chipStorageProvider',
        defaultMessage: 'Storage Provider',
        description: 'Storage Provider domain option label',
      }),
    },
    crm: {
      id: 'crm',
      label: 'CRM',
    },
    procurement: {
      id: 'procurement',
      label: intl.formatMessage({
        id: 'Integrations.chipProcurement',
        defaultMessage: 'Procurement',
        description: 'Procurement domain option label',
      }),
    },
    'developer tools': {
      id: 'developer tools',
      label: intl.formatMessage({
        id: 'Integrations.chipDeveloperTools',
        defaultMessage: 'Developer Tools',
        description: 'Developer Tools domain option label',
      }),
    },
  };
};

export const getDomainOptions = (
  intl: IntlShape,
): Array<{ label: string; value: string }> => {
  const domainKeys = getDomainKeys(intl);
  return Object.values(domainKeys).map((key) => ({
    label: key.label,
    value: key.id,
  }));
};

export const getCategoriesOptions = (
  intl: IntlShape,
): Array<{ label: string; value: string }> => {
  return [
    {
      label: 'Workday',
      value: 'workday',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.categoryElectronicSignature',
        defaultMessage: 'Electronic Signature',
        description: 'Electronic Signature category label',
      }),
      value: 'electronic signature',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.categoryDocumentEditing',
        defaultMessage: 'Document Editing',
        description: 'Document Editing category label',
      }),
      value: 'document editing',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.categoryDocumentManagement',
        defaultMessage: 'Document Management',
        description: 'Document Management category label',
      }),
      value: 'document management',
    },
    {
      label: 'CRM',
      value: 'crm',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.categoryProcurement',
        defaultMessage: 'Procurement',
        description: 'Procurement category label',
      }),
      value: 'procurement',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.categoryDeveloperTools',
        defaultMessage: 'Developer Tools',
        description: 'Developer Tools category label',
      }),
      value: 'developer tools',
    },
  ];
};

export const getAccessOptions = (
  intl: IntlShape,
): Array<{ label: string; value: string }> => {
  return [
    {
      label: intl.formatMessage({
        id: 'Integrations.accessAvailable',
        defaultMessage: 'Available',
        description: 'Available access option label',
      }),
      value: 'configure',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.accessEarlyAccess',
        defaultMessage: 'Early Access',
        description: 'Early Access option label',
      }),
      value: 'early access',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.accessConfigured',
        defaultMessage: 'Configured',
        description: 'Configured access option label',
      }),
      value: 'configured',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.accessComingSoon',
        defaultMessage: 'Coming Soon',
        description: 'Coming Soon access option label',
      }),
      value: 'coming soon',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.accessFutureDevelopment',
        defaultMessage: 'Future Development',
        description: 'Future Development access option label',
      }),
      value: 'future development',
    },
    {
      label: intl.formatMessage({
        id: 'Integrations.accessReconnect',
        defaultMessage: 'Reconnect',
        description: 'Reconnect access option label',
      }),
      value: 'reconnect',
    },
  ];
};
